"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PoseGroupItem = exports.PreloaderElement = exports.pulsatingAnimation = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _reactPose = _interopRequireDefault(require("react-pose"));

var _core = require("@emotion/core");

var _emotion = require("@rebass/grid/emotion");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = process.env.NODE_ENV === "production" ? {
  name: "z92mj8",
  styles: "animation-duration:2s;animation-fill-mode:forwards;animation-iteration-count:infinite;animation-name:placeholder-pulsate;animation-timing-function:ease-in-out;@keyframes placeholder-pulsate{0%{opacity:0.5;}50%{opacity:1;}100%{opacity:0.5;}}"
} : {
  name: "z92mj8",
  styles: "animation-duration:2s;animation-fill-mode:forwards;animation-iteration-count:infinite;animation-name:placeholder-pulsate;animation-timing-function:ease-in-out;@keyframes placeholder-pulsate{0%{opacity:0.5;}50%{opacity:1;}100%{opacity:0.5;}}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9za2VsZXRvbi1wcmVsb2FkZXIvaW5kZXguanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSzJDIiwiZmlsZSI6Ii4uLy4uL3NyYy9za2VsZXRvbi1wcmVsb2FkZXIvaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgcG9zZWQgZnJvbSAncmVhY3QtcG9zZSc7XG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IEJveCB9IGZyb20gJ0ByZWJhc3MvZ3JpZC9lbW90aW9uJztcblxuZXhwb3J0IGNvbnN0IHB1bHNhdGluZ0FuaW1hdGlvbiA9ICgpID0+IGNzc2BcbiAgYW5pbWF0aW9uLWR1cmF0aW9uOiAycztcbiAgYW5pbWF0aW9uLWZpbGwtbW9kZTogZm9yd2FyZHM7XG4gIGFuaW1hdGlvbi1pdGVyYXRpb24tY291bnQ6IGluZmluaXRlO1xuICBhbmltYXRpb24tbmFtZTogcGxhY2Vob2xkZXItcHVsc2F0ZTtcbiAgYW5pbWF0aW9uLXRpbWluZy1mdW5jdGlvbjogZWFzZS1pbi1vdXQ7XG4gIEBrZXlmcmFtZXMgcGxhY2Vob2xkZXItcHVsc2F0ZSB7XG4gICAgMCUge1xuICAgICAgb3BhY2l0eTogMC41O1xuICAgIH1cbiAgICA1MCUge1xuICAgICAgb3BhY2l0eTogMTtcbiAgICB9XG4gICAgMTAwJSB7XG4gICAgICBvcGFjaXR5OiAwLjU7XG4gICAgfVxuICB9XG5gO1xuXG5leHBvcnQgY29uc3QgUHJlbG9hZGVyRWxlbWVudCA9IHN0eWxlZChCb3gpYFxuICBiYWNrZ3JvdW5kLWNvbG9yOiAkeyhwcm9wcykgPT4gcHJvcHMudGhlbWUuY29sb3JzLm5ldXRyYWxbNF19O1xuYDtcblxuZXhwb3J0IGNvbnN0IFBvc2VHcm91cEl0ZW0gPSBwb3NlZC5kaXYoe1xuICBlbnRlcjogeyBvcGFjaXR5OiAxLCB5OiAwLCB0cmFuc2l0aW9uOiB7IGR1cmF0aW9uOiA1MDAsIGVhc2U6ICdlYXNlSW4nLCBkZWxheTogNTAgfSB9LFxuICBleGl0OiB7IG9wYWNpdHk6IDAsIHk6ICcxMHB4JywgdHJhbnNpdGlvbjogeyBkdXJhdGlvbjogNTAwLCBlYXNlOiAnZWFzZU91dCcgfSB9XG59KTtcbiJdfQ== */"
};

var pulsatingAnimation = function pulsatingAnimation() {
  return _ref;
};

exports.pulsatingAnimation = pulsatingAnimation;
var PreloaderElement = (
/*#__PURE__*/
0, _styledBase.default)(_emotion.Box, {
  target: "e1pobnxm0"
})("background-color:", function (props) {
  return props.theme.colors.neutral[4];
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9za2VsZXRvbi1wcmVsb2FkZXIvaW5kZXguanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBd0IyQyIsImZpbGUiOiIuLi8uLi9zcmMvc2tlbGV0b24tcHJlbG9hZGVyL2luZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHBvc2VkIGZyb20gJ3JlYWN0LXBvc2UnO1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBCb3ggfSBmcm9tICdAcmViYXNzL2dyaWQvZW1vdGlvbic7XG5cbmV4cG9ydCBjb25zdCBwdWxzYXRpbmdBbmltYXRpb24gPSAoKSA9PiBjc3NgXG4gIGFuaW1hdGlvbi1kdXJhdGlvbjogMnM7XG4gIGFuaW1hdGlvbi1maWxsLW1vZGU6IGZvcndhcmRzO1xuICBhbmltYXRpb24taXRlcmF0aW9uLWNvdW50OiBpbmZpbml0ZTtcbiAgYW5pbWF0aW9uLW5hbWU6IHBsYWNlaG9sZGVyLXB1bHNhdGU7XG4gIGFuaW1hdGlvbi10aW1pbmctZnVuY3Rpb246IGVhc2UtaW4tb3V0O1xuICBAa2V5ZnJhbWVzIHBsYWNlaG9sZGVyLXB1bHNhdGUge1xuICAgIDAlIHtcbiAgICAgIG9wYWNpdHk6IDAuNTtcbiAgICB9XG4gICAgNTAlIHtcbiAgICAgIG9wYWNpdHk6IDE7XG4gICAgfVxuICAgIDEwMCUge1xuICAgICAgb3BhY2l0eTogMC41O1xuICAgIH1cbiAgfVxuYDtcblxuZXhwb3J0IGNvbnN0IFByZWxvYWRlckVsZW1lbnQgPSBzdHlsZWQoQm94KWBcbiAgYmFja2dyb3VuZC1jb2xvcjogJHsocHJvcHMpID0+IHByb3BzLnRoZW1lLmNvbG9ycy5uZXV0cmFsWzRdfTtcbmA7XG5cbmV4cG9ydCBjb25zdCBQb3NlR3JvdXBJdGVtID0gcG9zZWQuZGl2KHtcbiAgZW50ZXI6IHsgb3BhY2l0eTogMSwgeTogMCwgdHJhbnNpdGlvbjogeyBkdXJhdGlvbjogNTAwLCBlYXNlOiAnZWFzZUluJywgZGVsYXk6IDUwIH0gfSxcbiAgZXhpdDogeyBvcGFjaXR5OiAwLCB5OiAnMTBweCcsIHRyYW5zaXRpb246IHsgZHVyYXRpb246IDUwMCwgZWFzZTogJ2Vhc2VPdXQnIH0gfVxufSk7XG4iXX0= */"));
exports.PreloaderElement = PreloaderElement;

var PoseGroupItem = _reactPose.default.div({
  enter: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 500,
      ease: 'easeIn',
      delay: 50
    }
  },
  exit: {
    opacity: 0,
    y: '10px',
    transition: {
      duration: 500,
      ease: 'easeOut'
    }
  }
});

exports.PoseGroupItem = PoseGroupItem;